var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.info ? _vm.info.endDate.substring(0, 10) : null
  var g1 = _vm.info ? _vm.info.endDate.substring(0, 10) : null
  var g2 = _vm.info ? _vm.info.relationInfoList.join("、") : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }